import React, { useState, useEffect } from 'react';
import Spiner from '../Components/Admin/Spiner/Spiner';
import { Outlet, useLocation, Navigate } from 'react-router-dom';
import Auth from '../Components/Admin/Auth/Auth';
import baseURL from '../Components/url';

const routeToModule = {
    '/dashboard/reportes': 'reportes',
    '/dashboard/pacientes': 'pacientes',
    '/dashboard/profesionales': 'profesionales',
    '/dashboard/productos': 'productos',
    '/dashboard/pedidos': 'pedidos',
    '/dashboard/inventarios': 'inventarios',
    '/dashboard/gastos': 'gastos',
    '/dashboard/evaluaciones': 'evaluaciones',
    '/dashboard/medios-pago': 'medios-pago',
    '/dashboard/categorias': 'categorias',
    '/dashboard/banners': 'banners',
    '/dashboard/contacto': 'contacto',
    '/dashboard/usuarios': 'usuarios',
    '/dashboard/codigos': 'codigos',
    '/dashboard/testimonios': 'testimonios',
    '/dashboard/sucursales': 'sucursales',
    '/dashboard/horarios': 'horarios',
    '/dashboard/pwa': 'pwa',
    '/dashboard/configuracion': 'configuracion'
};

export default function MainLayout() {
    const storedUser = sessionStorage.getItem('usuario');
    const [usuario, setUsuario] = useState(storedUser ? JSON.parse(storedUser) : {});
    const [loading, setLoading] = useState(true);
    const location = useLocation();

    useEffect(() => {
        const fetchData = async () => {
            try {
                // Si ya tenemos el usuario en sessionStorage, lo usamos inmediatamente y no bloqueamos la interfaz
                const stored = sessionStorage.getItem('usuario');
                if (stored) {
                    try {
                        const parsed = JSON.parse(stored);
                        if (parsed && parsed.idUsuario) {
                            setUsuario(parsed);
                            setLoading(false);
                            // Verificación en segundo plano sin interrumpir ni borrar la sesión local si falla
                            fetch(`${baseURL}/userLogued.php`, { credentials: 'include' })
                                .then(res => res.json())
                                .then(data => {
                                    if (data && data.idUsuario) {
                                        setUsuario(data);
                                        sessionStorage.setItem('usuario', JSON.stringify(data));
                                    }
                                })
                                .catch(err => console.log("Background session sync skipped:", err));
                            return;
                        }
                    } catch (e) {
                        console.error("Error parsing stored user:", e);
                    }
                }

                const response = await fetch(`${baseURL}/userLogued.php`, {
                    credentials: 'include'
                });
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                const data = await response.json();
                if (data && data.idUsuario) {
                    setUsuario(data);
                    sessionStorage.setItem('usuario', JSON.stringify(data));
                } else {
                    setUsuario({});
                    sessionStorage.removeItem('usuario');
                }
                setLoading(false);

            } catch (error) {
                console.error('Error al obtener datos:', error);
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    const hasPermission = (module, action) => {
        if (!usuario || !usuario.rol) return false;
        if (usuario.rol === 'admin') return true;
        if (usuario.rol === 'empleado') {
            let permisos = usuario.permisos;
            if (typeof permisos === 'string') {
                try {
                    permisos = JSON.parse(permisos);
                } catch (e) {
                    permisos = {};
                }
            }
            if (!permisos) return false;
            const modPerm = permisos[module];
            if (modPerm) {
                return !!modPerm[action];
            }
        }
        return false;
    };

    if (loading) {
        return <Spiner />;
    }

    if (!usuario || !usuario.idUsuario) {
        return <Auth />;
    }

    const activeModule = routeToModule[location.pathname];
    if (activeModule && !hasPermission(activeModule, 'ver')) {
        return <Navigate to="/dashboard" replace />;
    }

    const canEditActiveModule = activeModule ? hasPermission(activeModule, 'editar') : true;

    return (
        <div>
            <div className={!canEditActiveModule ? 'no-edit-module' : ''}>
                <Outlet context={{ usuario }} />
            </div>
        </div>
    );
}
